import React, { Fragment, useContext, useEffect, useState } from "react";
import styled, { css } from "styled-components";
import DefaultContainer from "../../../components/UI/Container/DefaultContainer";
import HeaderNavigate from "../../../components/UI/Header/HeaderNavigate";
import { Button, List } from "../../../components";
import IdCardFloatLayer from "../../../components/UI/Layer/IdCardFloatLayer/IdCardFloatLayer";
import { IC, ListIcon } from "../../../resources/Assets";
import { inputDotInDate } from "../../../modules/utils/CheckLogic";
import Label from "../../../components/UI/Label/Label";
import { AppContext } from "../../../components/AppProvider";
import LabelButton from "../../../components/UI/Label/LabelButton";
import { PostApi1976 } from "../../../modules/network/padoPost";
import { BottomBtnArea } from "./ReceiptStyle";
import FloatButton from "../../../components/UI/Button/FloatButton";

const TargetManagement = props => {
  const { userinfo, cfg, phonecfg } = useContext(AppContext);
  const {
    setPageType,
    setRqstRelCd,
    setFamzSeqNo,
    famzSeqNo,
    familyInfo,
    setFamilyInfo,
    familyList,
  } = props;
  const [idCardFloatView, setIdCardFloatView] = useState(false);
  // const [familyList, setFamilyList] = useState();

  const [famzSeqNoTemp, setFamzSeqNoTemp] = useState(famzSeqNo);
  const [rqstRelCdTemp, setRqstRelCdTemp] = useState("PRCP");

  const [familyInfoTemp, setFamilyInfoTemp] = useState(familyInfo);

  // const getFamilyList = () => {
  //   PostApi1976(userinfo, cfg, phonecfg)
  //     .then(res => {
  //       setFamilyList(res.result);
  //     })
  //     .catch(err => {
  //       console.log("ERR getFamilyList:: ", err);
  //     });
  // };

  // useEffect(() => {
  //   getFamilyList();
  // }, []);

  return (
    <Fragment>
      <DefaultContainer>
        <HeaderNavigate
          leftIcon={{
            imgSrc: IC.etc.ICON_CHEVRON_LEFT,
            action: () => setPageType("default"),
          }}
          headerTitle="진료대상 선택"
        />

        <ContentsBody>
          <ContentBody>
            <ListBody>
              <div
                style={{ width: "100%" }}
                onClick={() => {
                  setFamilyInfoTemp({
                    rqstRelCd: "PRCP",
                    famzNm: userinfo.userName,
                    famzBirthDt: userinfo.birth,
                    famzGndr: userinfo.sex,
                    famzTelNo: userinfo.userPhone,
                    famzFileNm: userinfo.userName,
                    famzSeqNo: "",
                  });
                }}>
                <List
                  data={{
                    STATUS:
                      familyInfoTemp.famzSeqNo === "" ? "active" : "default",
                    CONTAINER_SHORT: false,
                    // L_ICON: "",
                    L_ICON: (
                      <RadioBtn
                        active={familyInfoTemp.famzSeqNo === "" ? true : false}
                      />
                    ),
                    TITLE: (
                      <div
                        style={{
                          display: "flex",
                          flexFlow: "column",
                          gap: "8px",
                        }}>
                        <div style={{ width: "29px" }}>
                          <Label
                            data={{
                              status: "active",
                              text: "본인",
                            }}
                          />
                        </div>
                        <div>{userinfo.userName}</div>
                      </div>
                    ),
                    SUB_TEXT: {
                      status: "default",
                      text: inputDotInDate(userinfo.birth),
                    },
                    R_ICON: "",
                  }}
                />
              </div>

              {familyList && familyList.length > 0 && (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexFlow: "column",
                    gap: "8px",
                  }}>
                  <div style={{ fontSize: "14px", fontWeight: "500" }}>
                    가족 목록
                  </div>
                  {familyList.map((family, idx) => (
                    <div
                      style={{ width: "100%" }}
                      onClick={() => {
                        setFamilyInfoTemp({
                          rqstRelCd: "FAMZ",
                          famzNm: family.famzNm,
                          famzBirthDt: family.famzBirthDt,
                          famzGndr: family.famzGndr,
                          famzTelNo: family.famzTelNo,
                          famzFileNm: family.famzFileNm,
                          famzSeqNo: family.famzSeqNo,
                        });
                      }}
                      key={"fmlInfo" + idx}>
                      <List
                        data={{
                          STATUS:
                            familyInfoTemp.famzSeqNo === family.famzSeqNo
                              ? "active"
                              : "default",
                          CONTAINER_SHORT: false,
                          // L_ICON: "",
                          L_ICON: (
                            <RadioBtn
                              active={
                                familyInfoTemp.famzSeqNo === family.famzSeqNo
                                  ? true
                                  : false
                              }
                            />
                          ),
                          TITLE: (
                            <div
                              style={{
                                display: "flex",
                                flexFlow: "column",
                                gap: "8px",
                              }}>
                              <div>{family.famzNm}</div>
                            </div>
                          ),
                          SUB_TEXT: {
                            status: "default",
                            text: inputDotInDate(family.famzBirthDt),
                          },
                          R_ICON: "",
                        }}
                      />
                    </div>
                  ))}
                </div>
              )}
            </ListBody>

            <LabelButton
              htmlFor={""}
              severity="light"
              disable="on"
              L_ICON={IC.etc.ICON_GRAY_PLUS}
              clickEvent={() => setPageType("add")}>
              가족 추가
            </LabelButton>
          </ContentBody>
        </ContentsBody>

        {/* <BottomBtnArea>
          <Button
            severity="primary"
            disable="off"
            clickEvent={() => {
              setFamilyInfo(familyInfoTemp);
              setPageType("default");
            }}>
            확인
          </Button>
        </BottomBtnArea> */}

        <FloatButton
          severity="primary"
          disable="off"
          padding={true}
          bottomMenu={false}
          event={() => {
            setFamilyInfo(familyInfoTemp);
            setPageType("default");
          }}
          text="확인"
        />
      </DefaultContainer>
      {idCardFloatView && (
        <IdCardFloatLayer
          data={{
            header: {
              img: IC.close.ICON_CLOSE_X,
              text: "신분증 사진",
              event: () => alert("닫기"),
            },
            body: {
              contents: [
                {
                  text: "카메라 촬영",
                  img: IC.etc.ICON_CAMERA,
                },
                {
                  text: "갤러리에서 선택",
                  img: IC.etc.ICON_GALLERY,
                },
              ],
            },
          }}
        />
      )}
    </Fragment>
  );
};

const ContentsBody = styled.div`
  width: 100vw;
  height: calc(100vh - 179px);
  overflow-y: auto;
  display: flex;
  flex-flow: column;
  gap: 16px;
`;

const ContentBody = styled.div`
  flex-grow: 0;
  display: flex;
  /* flex: 1 0 auto; */
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  padding: 40px 20px 24px 20px;
  background-color: #fff;
`;

const ListBody = styled.div`
  width: 100%;
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 24px;
  padding: 0;
`;

const RadioBtn = styled.div`
  ${props =>
    props.active
      ? css`
          /* margin: 23px 12px 23px 0;
          border-radius: 12px;
          border: solid 6px #6b65de; */
          width: 12px;
          height: 12px;

          flex-grow: 0;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: stretch;
          gap: 10px;
          padding: 0;
          border-radius: 12px;
          border: solid 6px #6b65de;
          background-color: #fff;
        `
      : css`
          width: 22px;
          height: 22px;
          flex-grow: 0;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: stretch;
          gap: 10px;
          padding: 0;
          border-radius: 12px;
          border: solid 1px #efefef;
          background-color: #fff;
        `}
`;
export default TargetManagement;
